export { ContaminantResultCard } from './ContaminantResultCard';
